var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.5,71.7h-1l-7.8-36.5c-0.7-2.9-0.9-5.4-0.9-5.4v-1l2.6-1.2v-3.2h0c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9h0v2.5  c0,0-2.1,0-6.4,0c0,0-27.2-0.5-27.2-7.9l0-5.7c0,0,0,0,0,0c0-0.5-0.4-0.9-0.9-0.9c0,0,0,0,0,0s0,0,0,0c-0.5,0-0.9,0.4-0.9,0.9  c0,0,0,0,0,0l0,5.7c0,7.3-27.2,7.9-27.2,7.9c-4.3,0-6.4,0-6.4,0v-2.5h0c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9h0v3.2l2.6,1.2  v1c0,0-0.2,2.5-0.9,5.4L7.5,71.7h-1c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4h22.4c0.8,0,1.4-0.6,1.4-1.4  c0-0.8-0.6-1.4-1.4-1.4H28l-8.4-37.5c-0.7-3-0.7-4.6-0.7-4.6v-0.8h29.3v47.6h0c-0.3,7.3-5.8,8.3-7.9,8.4h-3.1h0  c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4h0h25.8h0c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4h0h-3.1  c-2.1-0.1-7.6-1.1-7.9-8.4h0V28.8h29.3v0.8c0,0,0,1.6-0.7,4.6L72,71.7h-0.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4h22.4  c0.8,0,1.4-0.6,1.4-1.4C95,72.4,94.3,71.7,93.5,71.7z M26.6,71.7H10.1l7.2-36.1c0,0,0.5-3.9,1.3,0.4L26.6,71.7z M73.4,71.7L81.4,36  c0.8-4.3,1.3-0.4,1.3-0.4l7.2,36.1H73.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJust);
export default __webpack_public_path__ + "static/media/just.ad04ab9843efaa83857728c5037bcaa9.svg";
export { ForwardRef as ReactComponent };